module.exports = __webpack_public_path__ + "static/media/017.039bde8e.jpg";